<div class="holder" [ngStyle]="{'width': size, 'height': size}">
  <img *ngIf="imageUrl" [src]="imageUrl">
  <canvas #canvas [style]="{'border': border + 'px solid white'}"></canvas>
</div>
